import type { ReactNode } from 'react';
import styles from './TableSection.module.css';

// A table's own heading, with no card around it (DECISIONS-LOG 2026-10-06 "A colour for every
// status, no grey anywhere": tables are tables, not cards). Sized like a card title so the page's
// hierarchy reads the same either way.

interface TableSectionProps {
  /** A scroll target, for a notification or link that opens this section. */
  readonly id?: string;
  readonly title: string;
  readonly meta?: string;
  /** A link or button beside the title — "How this is counted", "Open the full screen". */
  readonly action?: ReactNode;
  readonly children: ReactNode;
}

export function TableSection({ id, title, meta, action, children }: TableSectionProps): ReactNode {
  return (
    <section id={id} className={styles.section}>
      <header className={styles.header}>
        <div className={styles.text}>
          <h2 className={styles.title}>{title}</h2>
          {meta !== undefined && <p className={styles.meta}>{meta}</p>}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}
